@if (condition) {
  <div class="open-task-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      @if (tasks != null && tasks.length > 0) {
        <mat-form-field class="flex-grow" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.open-task-editor.has-open-task-of-type"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="taskTypeExternalKey" name="taskTypeExternalKey">
            @for (task of tasks; track task) {
              <mat-option [value]="task.externalKey">
                <sc-dictionary-label [dictionaryKey]="task.nameDictionaryKey"></sc-dictionary-label>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </div>
}
